import { render, staticRenderFns } from "./UserRolesForm.vue?vue&type=template&id=0d2aaabe&scoped=true"
import script from "./UserRolesForm.vue?vue&type=script&lang=js"
export * from "./UserRolesForm.vue?vue&type=script&lang=js"
import style0 from "./UserRolesForm.vue?vue&type=style&index=0&id=0d2aaabe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2aaabe",
  null
  
)

export default component.exports